import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
import LocalizedStrings from "react-localization";

let localizationStrings = new LocalizedStrings({
  en: {
    link: "Retract Access Video",
  },
  ja: {
    link: "アクセス権の取り消しビデオ",
  },
  es: {
    link: "Vídeo de Retirar Acceso",
  },
});

class Retract_Access_video extends Component {
  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          localizationStrings.setLanguage(snapshot.val());
        });
    }
  }

  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    const containerStyle = {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    };

    const linkStyle = {
      textAlign: "center",
      textDecoration: "underline",
      color: "black",
    };

    return (
      <div style={containerStyle}>
        <a
          href="https://youtu.be/y72ZXhGEEwU?si=gkEvRYH0gIdXdKmB"
          target="_blank"
          style={linkStyle}
        >
          {localizationStrings.link}
        </a>
      </div>
    );
  }
}

export default Retract_Access_video;
